export default {
  'PageSelector.NextPage': ({ pageNumber, pagesCount }, outlet) => {
    if (pageNumber < pagesCount - 1) {
      outlet({ pageNumber: pageNumber + 1 });
    }
  },

  'PageSelector.PrevPage': ({ pageNumber }, outlet) => {
    if (pageNumber > 0) {
      outlet({ pageNumber: pageNumber - 1 });
    }
  },

  'PageSelector.FirstPage': ({ pageNumber }, outlet) => {
    if (pageNumber > 0) {
      outlet({ pageNumber: 0 });
    }
  },

  'PageSelector.LastPage': ({ pageNumber, pagesCount }, outlet) => {
    if (pageNumber < pagesCount - 1) {
      outlet({ pageNumber: pagesCount - 1 });
    }
  },

  'PageSelector.PageNumber': ({ navigationPage, pageNumber }, outlet) => {
    outlet({ pageNumber: navigationPage + pageNumber })
  },
}